import { TableHeading, TableData } from "../table/table-heading";
import { formatDate } from "../../utils/utils";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";

import { useState } from "react";
import RoundedButton from "../buttons/RoundedButton";

export default function UserList({ users, onClick }) {
  const [isOpen, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState([]);

  function handleClick(item) {
    onClick({
      item,
    });
  }

  return (
    <>
      <table className="table-auto w-full rounded-md">
        <thead className="bg-slate-300">
          <tr>
            <TableHeading name={"S.No."} />
            <TableHeading name={"Id"} />
            <TableHeading name={"Name"} />
            <TableHeading name={"Mobile"} />
            <TableHeading name={"DOB"} />
            <TableHeading name={"Image"} />
            <TableHeading name={"Prediction"} />

            <TableHeading name={"Created At"} />
            <TableHeading name={"Action"} />
          </tr>
        </thead>
        <tbody className="bg-transparent">
          {users.map((item, index) => (
            <tr className="border-b border-gray-300" key={item._id}>
              <TableData>{index + 1}</TableData>
              <TableData>{item._id}</TableData>
              <TableData>{item.name}</TableData>
              <TableData>{item.mobile}</TableData>
              <TableData>{`${item.dob ?? ""} ${item.place_of_birth ?? ""} ${
                item.time_of_birth ?? ""
              }`}</TableData>
              <TableData>
                <img
                  src={item.image}
                  alt={item.name}
                  onClick={() => {
                    // Ensure it's an array of slide objects: [{ src: '...' }]
                    const slides = Array.isArray(item.images)
                      ? item.images.map((img) => ({ src: img }))
                      : [{ src: item.image }];
                    setCurrentImage(slides);
                    setOpen(true);
                  }}
                  className="w-24 h-24 object-cover"
                />
              </TableData>
              <TableData>
                <div className="text-sm font-sans">{item.prediction}</div>
              </TableData>
              <TableData>{formatDate(item.created_date)}</TableData>
              <TableData>
                <RoundedButton
                  onClick={() => handleClick(item)}
                  text={"Edit"}
                />
              </TableData>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Lightbox outside the map */}
      {currentImage && (
        <Lightbox
          open={isOpen}
          close={() => setOpen(false)}
          slides={currentImage}
          plugins={[Zoom]}
        />
      )}
    </>
  );
}
